import { LOGS_PATH } from 'devices/navigation';

const indexComponent = require('./routes/index/components/DeviceLogsList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: LOGS_PATH,
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceLogs'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/show/routes/logs/index.js